export default class HeaderUtils {
    static slpitDataType(str: string, separator: any) {
        return str.split(separator);
    }
}